const renderNarrative = (part, t) => {
  if (!part) return <p>{t('playStory.noText')}</p>;

  if (typeof part === 'string') {
    return part.split('\n').map((line, i) => (
      <p key={i}>{line}</p>
    ));
  }

  if (Array.isArray(part)) {
    return part.map((block, i) => {
      if (block.type === 'dialogue') {
        return (
          <p key={i} className="dialogue-line">
            <strong>{block.speaker ? `${block.speaker}: ` : ''}</strong>{block.text}
          </p>
        );
      } else if (block.type === 'title') {
        return <h4 key={i}>{block.text}</h4>;
      } else {
        return <p key={i}>{block.text}</p>;
      }
    });
  }

  return <p>{t('playStory.invalidTextFormat')}</p>;
};

export default renderNarrative;